<div class="modal-header pb-0">
  <ng-container [ngTemplateOutlet]="titleTemplate || defaultTitleTemplate"></ng-container>
</div>

<div class="modal-body d-flex gap-4 flex-column">
  <ng-container [ngTemplateOutlet]="descriptionTemplate || defaultDescriptionTemplate"></ng-container>

  <div class="form-group" *ngIf="hardConfirm">
        <textarea type="text" [(ngModel)]="hardConfirmText" class="form-control custom-control-value-element"
                  [placeholder]="'COMMON.WRITE_CONFIRM' | translate"
                  id="description-input"
                  rows="3"></textarea>
  </div>
</div>

<div class="d-flex modal-footer">
  <button type="button"
          class="btn btn-link btn-link-primary w-50" *ngIf="showCancelButton"
          (click)="close()">{{ cancelButtonText | translate:data }}
  </button>
  <button type="button"
          class="btn btn-primary w-50" [disabled]="hardConfirm && hardConfirmText !== 'Potwierdzam'"
          (click)="ok(true)">{{ confirmButtonText | translate:data }}
  </button>
</div>

<!--Templates-->
<ng-template #defaultTitleTemplate>
  <div class="header" [innerHtml]="title | translate: data"></div>
</ng-template>

<ng-template #defaultDescriptionTemplate>
  <small [innerHtml]="description | translate: data"></small>
</ng-template>
